<div id="main-map" leaflet *ngIf="!!mapOptions" class="map" [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)" [(leafletCenter)]="mapCenter">
</div>